import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { usePacienteEditar } from '../hooks/usePacienteEditar';
import { useForm, useFormValidation } from '../../../hooks';

import { Acordion, DateInput, EmailInput, LightButton, MultiFormTutor, PrimaryButton, ReactSelectSingleInput, TelInput, TextInput, ZipCodeInput } from '../../../components';

import { eliminarUndefined } from '../../../helpers';

import styles from '../PacienteEditar.module.css';

export const PacienteEditarForm = ({ paciente, configuracionDatosGenerales }) => {

    const navigate = useNavigate();

    const { updatePacienteMutation: { mutate: updatePaciente, isPending } } = usePacienteEditar();

    const { nombre, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, email, celular, telefono, medioContacto, calle, numeroExterior, numeroInterior, colonia, municipio, entidadFederativa, pais, codigoPostal, nacionalidad, estadoCivil, ocupacion, religion, origen, residencia, tutores, appActiva, onInputChange } = useForm({ nombre: (typeof paciente.nombre !== 'undefined') ? paciente.nombre : '', apellidoPaterno: (typeof paciente.apellidoPaterno !== 'undefined') ? paciente.apellidoPaterno : '', apellidoMaterno: (typeof paciente.apellidoMaterno !== 'undefined') ? paciente.apellidoMaterno : '', fechaNacimiento: (typeof paciente.fechaNacimiento !== 'undefined') ? paciente.fechaNacimiento : '', genero: (typeof paciente.genero !== 'undefined') ? paciente.genero : '', email: paciente.email, celular: (typeof paciente.celular !== 'undefined') ? paciente.celular : '', telefono: (typeof paciente.telefono !== 'undefined') ? paciente.telefono : '', medioContacto: (typeof paciente.medioContacto !== 'undefined') ? paciente.medioContacto : '', calle: (typeof paciente.calle !== 'undefined') ? paciente.calle : '', numeroExterior: (typeof paciente.numeroExterior !== 'undefined') ? paciente.numeroExterior : '', numeroInterior: (typeof paciente.numeroInterior !== 'undefined') ? paciente.numeroInterior : '', colonia: (typeof paciente.colonia !== 'undefined') ? paciente.colonia : '', municipio: (typeof paciente.municipio !== 'undefined') ? paciente.municipio : '', entidadFederativa: (typeof paciente.entidadFederativa !== 'undefined') ? paciente.entidadFederativa : '', pais: (typeof paciente.pais !== 'undefined') ? paciente.pais : '', codigoPostal: (typeof paciente.codigoPostal !== 'undefined') ? paciente.codigoPostal : '', nacionalidad: (typeof paciente.nacionalidad !== 'undefined') ? paciente.nacionalidad : '', estadoCivil: (typeof paciente.estadoCivil !== 'undefined') ? paciente.estadoCivil : '', ocupacion: (typeof paciente.ocupacion !== 'undefined') ? paciente.ocupacion : '', religion: (typeof paciente.religion !== 'undefined') ? paciente.religion : '', origen: (typeof paciente.origen !== 'undefined') ? paciente.origen : '', residencia: (typeof paciente.residencia !== 'undefined') ? paciente.residencia : '', tutores: (typeof paciente.tutores !== 'undefined') ? paciente.tutores : [], appActiva: paciente.appActiva });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation } = useFormValidation([{field: 'nombre', default: true}, {field: 'apellidoPaterno', default: true}, {field: 'apellidoMaterno', default: true}, {field: 'fechaNacimiento', default: true}, {field: 'genero', default: true}, {field: 'email', default: true}, {field: 'celular', default: true}, {field: 'telefono', default: true}, {field: 'medioContacto', default: true}, {field: 'calle', default: true}, {field: 'numeroExterior', default: true}, {field: 'numeroInterior', default: true}, {field: 'colonia', default: true}, {field: 'municipio', default: true}, {field: 'entidadFederativa', default: true}, {field: 'pais', default: true}, {field: 'codigoPostal', default: true}, {field: 'nacionalidad', default: true}, {field: 'estadoCivil', default: true}, {field: 'ocupacion', default: true}, {field: 'religion', default: true}, {field: 'origen', default: true}, {field: 'residencia', default: true}, {field: 'tutores', default: true}, {field: 'appActiva', default: true}]);

    let generoOptions = ['Masculino', 'Femenino'];
    if(typeof configuracionDatosGenerales !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion.genero !== 'undefined'){
        if((typeof configuracionDatosGenerales.fichaIdentificacion.generoOtro !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.generoOtro) || paciente.genero === 'Otro'){
            generoOptions.push('Otro');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.generoPrefieroNoDecirlo !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.generoPrefieroNoDecirlo) || paciente.genero === 'Prefiero no decirlo'){
            generoOptions.push('Prefiero no decirlo');
        }
    }
    let medioContactoOptions = ['No especificado'];
    if(typeof configuracionDatosGenerales !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion.medioContacto !== 'undefined'){
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoInstagram !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoInstagram) || paciente.medioContacto === 'Instagram'){
            medioContactoOptions.push('Instagram');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoFacebook !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoFacebook) || paciente.medioContacto === 'Facebook'){
            medioContactoOptions.push('Facebook');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoTiktok !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoTiktok) || paciente.medioContacto === 'Tiktok'){
            medioContactoOptions.push('Tiktok');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoPaginaWeb !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoPaginaWeb) || paciente.medioContacto === 'Pagina web'){
            medioContactoOptions.push('Pagina web');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoReferenciaOtroDoctor !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoReferenciaOtroDoctor) || paciente.medioContacto === 'Referencia otro doctor'){
            medioContactoOptions.push('Referencia otro doctor');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoReferenciaFamiliar !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoReferenciaFamiliar) || paciente.medioContacto === 'Referencia familiar'){
            medioContactoOptions.push('Referencia familiar');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoReferenciaAmistad !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoReferenciaAmistad) || paciente.medioContacto === 'Referencia amistad'){
            medioContactoOptions.push('Referencia amistad');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoCentroMedico !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoCentroMedico) || paciente.medioContacto === 'Centro médico/hospital'){
            medioContactoOptions.push('Centro médico/hospital');
        }
        if((typeof configuracionDatosGenerales.fichaIdentificacion.medioContactoOtro !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.medioContactoOtro) || paciente.medioContacto === 'Otro'){
            medioContactoOptions.push('Otro');
        }
    }

    const handleViewPaciente = () => {
        navigate(`/paciente/view/${paciente._id}`);
    }

    // useEffect(() => {
    //     onInputChange({ target: { name: 'appActiva', value: appActivaContext } });
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [appActivaContext])

    const handleCanelarEditarPaciente = () => {
    
        navigate(-1);
    
    }
    
    const onSubmit = async ( event ) => {
        event.preventDefault();
            
        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updatePaciente({ data: eliminarUndefined({ nombre, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, email, celular, telefono, medioContacto, calle, numeroExterior, numeroInterior, colonia, municipio, entidadFederativa, pais, codigoPostal, nacionalidad, estadoCivil, ocupacion, religion, origen, residencia, tutores: JSON.stringify(tutores), appActiva: appActiva }, { apellidoMaterno: paciente.apellidoMaterno, telefono: paciente.telefono, calle: paciente.calle, numeroExterior: paciente.numeroExterior, numeroInterior: paciente.numeroInterior, colonia: paciente.colonia, municipio: paciente.municipio, entidadFederativa: paciente.entidadFederativa, pais: paciente.pais, codigoPostal: paciente.codigoPostal, nacionalidad: paciente.nacionalidad, estadoCivil: paciente.estadoCivil, ocupacion: paciente.ocupacion, religion: paciente.religion, origen: paciente.origen, residencia: paciente.residencia }), id: paciente._id, onSuccess: handleViewPaciente });
        }else{
            startFormValidation();
        }
    }

    return (
        <>
            <div className="row">
                <div className="col">
                    <div className={styles.panel + " " + styles.panelNoHeader}>
                        <div className={styles.header}>Editar Paciente</div>
                        <form  onSubmit={onSubmit}>
                            <div className={styles.panelSection}>
                                <div className={styles.subHeader}>Datos Generales</div>
                                <div className="row">
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['nombre'].status }
                                        label="Nombre(s)"
                                        name="nombre"
                                        onChange={ onInputChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ nombre }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['apellidoPaterno'].status }
                                        label="Apellido paterno"
                                        name="apellidoPaterno"
                                        onChange={ onInputChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ apellidoPaterno }
                                        />
                                    </div>
                                    {(configuracionDatosGenerales.fichaIdentificacion.apellidoMaterno) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['apellidoMaterno'].status }
                                        label="Apellido materno"
                                        name="apellidoMaterno"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ apellidoMaterno }
                                        />
                                    </div>
                                    }
                                    <div className="col-md-12 col-lg-4">
                                        <DateInput
                                        formFieldStatus={ formFields['fechaNacimiento'].status }
                                        label="Fecha de nacimiento"
                                        name="fechaNacimiento"
                                        onChange={ onInputChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ fechaNacimiento }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <ReactSelectSingleInput
                                            formFieldStatus={ formFields['genero'].status }
                                            label="Género"
                                            name="genero"
                                            onChange={ onInputChange }
                                            required={true}
                                            requiredIndicator={true}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={genero}
                                            values={generoOptions}
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <EmailInput
                                        formFieldStatus={ formFields['email'].status }
                                        label="Correo electrónico"
                                        name="email"
                                        onChange={ onInputChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ email }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <TelInput
                                        formFieldStatus={ formFields['celular'].status }
                                        label="Teléfono móvil"
                                        name="celular"
                                        onChange={ onInputChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ celular }
                                        />
                                    </div>
                                    {(configuracionDatosGenerales.fichaIdentificacion.telefono) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TelInput
                                        formFieldStatus={ formFields['telefono'].status }
                                        label="Teléfono fijo"
                                        name="telefono"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ telefono }
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.fichaIdentificacion.medioContacto) &&
                                    <div className="col-md-12 col-lg-4">
                                        <ReactSelectSingleInput
                                            formFieldStatus={ formFields['medioContacto'].status }
                                            label="Medio de contacto"
                                            name="medioContacto"
                                            onChange={ onInputChange }
                                            required={true}
                                            requiredIndicator={true}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={medioContacto}
                                            values={medioContactoOptions}
                                        />
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className={styles.panelSection}>
                                <div className={styles.subHeader}>Domicilio</div>
                                <div className="row">
                                    {(configuracionDatosGenerales.domicilio.calle) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['calle'].status }
                                        label="Calle"
                                        name="calle"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ calle }
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.domicilio.numero) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['numeroExterior'].status }
                                        label="# Exterior"
                                        name="numeroExterior"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ numeroExterior }
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.domicilio.numero) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['numeroInterior'].status }
                                        label="# Interior"
                                        name="numeroInterior"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ numeroInterior }
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.domicilio.colonia) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['colonia'].status }
                                        label="Colonia"
                                        name="colonia"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ colonia }
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.domicilio.municipio) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['municipio'].status }
                                        label="Municipio"
                                        name="municipio"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ municipio }
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.domicilio.entidadFederativa) &&
                                    <div className="col-md-12 col-lg-4">
                                        <ReactSelectSingleInput
                                            formFieldStatus={ formFields['entidadFederativa'].status }
                                            label="Entidad federativa"
                                            name="entidadFederativa"
                                            onChange={ onInputChange }
                                            required={false}
                                            requiredIndicator={false}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={entidadFederativa}
                                            values={['Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas', 'Chihuahua', 'Ciudad de México', 'Coahuila', 'Colima', 'Durango', 'Estado de México', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas']}
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.domicilio.pais) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                        formFieldStatus={ formFields['pais'].status }
                                        label="País"
                                        name="pais"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ pais }
                                        />
                                    </div>
                                    }
                                    {(configuracionDatosGenerales.domicilio.codigoPostal) &&
                                    <div className="col-md-12 col-lg-4">
                                        <ZipCodeInput
                                        formFieldStatus={ formFields['codigoPostal'].status }
                                        label="Código postal"
                                        name="codigoPostal"
                                        onChange={ onInputChange }
                                        required={ false }
                                        requiredIndicator={ false }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ codigoPostal }
                                        />
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className={styles.panelSection}>
                                <div className="row">
                                    <div className="col">
                                        <Acordion
                                            body={<>
                                                <div className="row">
                                                    {(configuracionDatosGenerales.fichaIdentificacion.nacionalidad) &&
                                                    <div className="col-md-12 col-lg-2">
                                                        <TextInput
                                                        formFieldStatus={ formFields['nacionalidad'].status }
                                                        label="Nacionalidad"
                                                        name="nacionalidad"
                                                        onChange={ onInputChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ nacionalidad }
                                                        />
                                                    </div>
                                                    }
                                                    {(configuracionDatosGenerales.fichaIdentificacion.estadoCivil) &&
                                                    <div className="col-md-12 col-lg-2">
                                                        <ReactSelectSingleInput
                                                            formFieldStatus={ formFields['estadoCivil'].status }
                                                            label="Estado civil"
                                                            name="estadoCivil"
                                                            onChange={ onInputChange }
                                                            required={false}
                                                            requiredIndicator={false}
                                                            setFormFieldValidation={ setFormFieldValidation }
                                                            value={estadoCivil}
                                                            values={['Soltero', 'Casado', 'Viudo', 'Divorciado', 'Unión libre']}
                                                        />
                                                    </div>
                                                    }
                                                    {(configuracionDatosGenerales.fichaIdentificacion.ocupacion) &&
                                                    <div className="col-md-12 col-lg-2">
                                                        <TextInput
                                                        formFieldStatus={ formFields['ocupacion'].status }
                                                        label="Ocupación"
                                                        name="ocupacion"
                                                        onChange={ onInputChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ ocupacion }
                                                        />
                                                    </div>
                                                    }
                                                    {(configuracionDatosGenerales.fichaIdentificacion.religion) &&
                                                    <div className="col-md-12 col-lg-2">
                                                        <TextInput
                                                        formFieldStatus={ formFields['religion'].status }
                                                        label="Religión"
                                                        name="religion"
                                                        onChange={ onInputChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ religion }
                                                        />
                                                    </div>
                                                    }
                                                    {(configuracionDatosGenerales.fichaIdentificacion.origen) &&
                                                    <div className="col-md-12 col-lg-2">
                                                        <TextInput
                                                        formFieldStatus={ formFields['origen'].status }
                                                        label="Origen"
                                                        name="origen"
                                                        onChange={ onInputChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ origen }
                                                        />
                                                    </div>
                                                    }
                                                    {(configuracionDatosGenerales.fichaIdentificacion.residencia) &&
                                                    <div className="col-md-12 col-lg-2">
                                                        <TextInput
                                                        formFieldStatus={ formFields['residencia'].status }
                                                        label="Residencia"
                                                        name="residencia"
                                                        onChange={ onInputChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ residencia }
                                                        />
                                                    </div>
                                                    }
                                                </div>
                                            </>}
                                            header={<div className={styles.subHeader}>Otros</div>}
                                            id='pacienteEditarOtrosAcordeon'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.panelSection}>
                                <div className="row">
                                    <div className="col">
                                        <Acordion
                                            body={<>
                                                <div className="row">
                                                    <div className="col">
                                                        <MultiFormTutor
                                                            formsStatus={ formFields['tutores'].status }
                                                            name="tutores"
                                                            onFormsChange={ onInputChange }
                                                            setFormValidation={ setFormFieldValidation }
                                                            value={tutores}
                                                        />
                                                    </div>
                                                </div>
                                            </>}
                                            header={<div className={styles.subHeader}>Tutores</div>}
                                            id='pacienteEditarTutoresAcordeon'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.panelSection}>
                                <div className="row">
                                    <div className="col-sm-12 col-md">
                                        <div className='d-flex justify-content-end'>
                                        <LightButton
                                            disabled={isPending || formValidationStatus === 'checking'}
                                            icon="X"
                                            marginRight={true}
                                            onClick={handleCanelarEditarPaciente}
                                            text="Cancelar"
                                            type="button"
                                        />
                                        <PrimaryButton
                                            disabled={isPending || formValidationStatus === 'checking'}
                                            icon="Check"
                                            text="Editar paciente"
                                            type="submit"
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

PacienteEditarForm.propTypes = {
    paciente: PropTypes.object.isRequired,
    configuracionDatosGenerales: PropTypes.object.isRequired,
}